import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Input, Label, FormGroup, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const KullaniciHaklari = () => {
  document.title = "Kullanıcı Hakları | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const [modal, setModal] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    KULLANICI_ID: null, Haklar_ID: null,
    AD_SOYAD: "", Mail_Adress: "",
    ILAN_HAKKI: 2, MEZAT_HAKKI: 0, DEGERLEME_HAKKI: 0, MEZAT_UZATMA_HAKKI: 0
  });

  const fetchUsers = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}/KULLANICILAR?$expand=KULLANICI_HAKLARI&$orderby=ID desc`, { headers });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const result = await res.json();
      setUsers(result.value || []);
    } catch (e) {
      setError(`Kullanıcılar yüklenirken hata oluştu: ${e.message || ""}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchUsers(); }, []);

  const handleEdit = (user) => {
    const haklar = user.KULLANICI_HAKLARI?.[0];
    setFormData({
      KULLANICI_ID: user.ID,
      Haklar_ID: haklar?.ID || null,
      AD_SOYAD: user.AD_SOYAD || "",
      Mail_Adress: user.Mail_Adress || "",
      ILAN_HAKKI: haklar?.ILAN_HAKKI ?? 2,
      MEZAT_HAKKI: haklar?.MEZAT_HAKKI ?? 0,
      DEGERLEME_HAKKI: haklar?.DEGERLEME_HAKKI ?? 0,
      MEZAT_UZATMA_HAKKI: haklar?.MEZAT_UZATMA_HAKKI ?? 0,
    });
    setError(null);
    setModal(true);
  };

  // Backend'den gelen hata mesajını oku
  const readApiError = async (response) => {
    try {
      const data = await response.json();
      // OData hata formu: { error: { message: "..." } } veya bizim controller'ın { message: "..." } formu
      return (
        data?.error?.message ||
        data?.message ||
        `Sunucu hatası (${response.status})`
      );
    } catch {
      return `Sunucu hatası (${response.status})`;
    }
  };

  const handleSave = async () => {
    if (!token) {
      setError("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.");
      return;
    }

    setIsSaving(true);
    setError(null);
    try {
      const payload = {
        KULLANICI_ID: formData.KULLANICI_ID,
        ILAN_HAKKI: Number(formData.ILAN_HAKKI),
        MEZAT_HAKKI: Number(formData.MEZAT_HAKKI),
        DEGERLEME_HAKKI: Number(formData.DEGERLEME_HAKKI),
        MEZAT_UZATMA_HAKKI: Number(formData.MEZAT_UZATMA_HAKKI),
      };

      let res;
      if (formData.Haklar_ID) {
        res = await fetch(`${BASE_URL}/KULLANICI_HAKLARI(${formData.Haklar_ID})`, {
          method: "PATCH", headers, body: JSON.stringify(payload),
        });
      } else {
        res = await fetch(`${BASE_URL}/KULLANICI_HAKLARI`, {
          method: "POST", headers, body: JSON.stringify(payload),
        });
      }

      if (!res.ok) {
        const msg = await readApiError(res);
        if (res.status === 403) {
          setError(`Yetkisiz işlem: ${msg}. Admin hesabıyla giriş yaptığınızdan emin olun ve tokenınızı yenileyin (çıkış→giriş).`);
        } else if (res.status === 401) {
          setError("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.");
        } else {
          setError(msg);
        }
        return;
      }

      setSuccessMsg(`${formData.AD_SOYAD} kullanıcısının hakları başarıyla güncellendi.`);
      setModal(false);
      fetchUsers();
      setTimeout(() => setSuccessMsg(""), 4000);
    } catch (e) {
      setError(`Kayıt sırasında hata: ${e.message || "bilinmeyen"}`);
    } finally {
      setIsSaving(false);
    }
  };

  const columns = useMemo(() => [
    {
      header: "#",
      accessorKey: "ID",
      enableSorting: true,
      cell: (c) => <strong>#{c.getValue()}</strong>,
    },
    {
      header: "Ad Soyad",
      accessorKey: "AD_SOYAD",
      enableSorting: true,
      cell: (c) => (
        <div className="d-flex align-items-center gap-2">
          <div className="avatar-xs">
            <span className="avatar-title rounded-circle bg-primary-subtle text-primary">
              {c.getValue()?.charAt(0)}
            </span>
          </div>
          <span>{c.getValue()}</span>
        </div>
      ),
    },
    {
      header: "E-posta",
      accessorKey: "Mail_Adress",
      enableSorting: false,
      cell: (c) => <span className="text-muted">{c.getValue() || "---"}</span>,
    },
    {
      header: "İlan",
      accessorKey: "KULLANICI_HAKLARI",
      id: "ilan",
      enableSorting: false,
      cell: (c) => {
        const val = c.getValue()?.[0]?.ILAN_HAKKI ?? null;
        return val !== null
          ? <Badge color="info" pill className="px-3 fs-6">{val}</Badge>
          : <Badge color="light" className="text-muted">Tanımsız</Badge>;
      },
    },
    {
      header: "Mezat",
      id: "mezat",
      accessorKey: "KULLANICI_HAKLARI",
      enableSorting: false,
      cell: (c) => {
        const val = c.getValue()?.[0]?.MEZAT_HAKKI ?? null;
        return val !== null
          ? <Badge color="warning" pill className="px-3 fs-6">{val}</Badge>
          : <Badge color="light" className="text-muted">Tanımsız</Badge>;
      },
    },
    {
      header: "Değerleme",
      id: "degerleme",
      accessorKey: "KULLANICI_HAKLARI",
      enableSorting: false,
      cell: (c) => {
        const val = c.getValue()?.[0]?.DEGERLEME_HAKKI ?? null;
        return val !== null
          ? <Badge color="success" pill className="px-3 fs-6">{val}</Badge>
          : <Badge color="light" className="text-muted">Tanımsız</Badge>;
      },
    },
    {
      header: "Mezat Uzatma",
      id: "uzatma",
      accessorKey: "KULLANICI_HAKLARI",
      enableSorting: false,
      cell: (c) => {
        const val = c.getValue()?.[0]?.MEZAT_UZATMA_HAKKI ?? null;
        return val !== null
          ? <Badge color="primary" pill className="px-3 fs-6">{val}</Badge>
          : <Badge color="light" className="text-muted">Tanımsız</Badge>;
      },
    },
    {
      header: "Son Güncelleme",
      id: "son_guncelleme",
      accessorKey: "KULLANICI_HAKLARI",
      enableSorting: false,
      cell: (c) => {
        const val = c.getValue()?.[0]?.SON_GUNCELLEME;
        return val
          ? <small className="text-muted">{new Date(val).toLocaleString("tr-TR")}</small>
          : <span className="text-muted">---</span>;
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      cell: (cellProps) => (
        <Button color="primary" size="sm" outline onClick={() => handleEdit(cellProps.row.original)}>
          <i className="bx bx-edit me-1" />
          Hakları Düzenle
        </Button>
      ),
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Hakları" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h4 className="card-title mb-1">Kullanıcı Hakları Yönetimi</h4>
                      <p className="text-muted small mb-0">
                        Tüm kullanıcıların ilan, mezat, değerleme ve mezat uzatma haklarını buradan yönetin.
                      </p>
                    </div>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={users}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Kullanıcı ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal isOpen={modal} toggle={() => setModal(false)} centered>
        <ModalHeader toggle={() => setModal(false)}>
          <i className="mdi mdi-shield-account me-2 text-primary"></i>
          Hakları Düzenle — {formData.AD_SOYAD}
        </ModalHeader>
        <ModalBody>
          <p className="text-muted small mb-3">
            <i className="mdi mdi-email-outline me-1"></i>{formData.Mail_Adress}
          </p>
          {error && <Alert color="danger" className="small">{error}</Alert>}
          <div className="alert alert-info small">
            <strong>0</strong> = Hak yok, pozitif sayı = hak miktarı. Varsayılan: İlan 2, Mezat 0, Değerleme 0, Uzatma 0.
          </div>
          <FormGroup>
            <Label className="fw-bold">
              <i className="mdi mdi-tag-multiple me-1 text-info"></i>İlan Hakkı
            </Label>
            <Input
              type="number" min="0"
              value={formData.ILAN_HAKKI}
              onChange={(e) => setFormData({ ...formData, ILAN_HAKKI: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label className="fw-bold">
              <i className="mdi mdi-gavel me-1 text-warning"></i>Mezat Hakkı
            </Label>
            <Input
              type="number" min="0"
              value={formData.MEZAT_HAKKI}
              onChange={(e) => setFormData({ ...formData, MEZAT_HAKKI: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label className="fw-bold">
              <i className="mdi mdi-star-check me-1 text-success"></i>Değerleme Hakkı
            </Label>
            <Input
              type="number" min="0"
              value={formData.DEGERLEME_HAKKI}
              onChange={(e) => setFormData({ ...formData, DEGERLEME_HAKKI: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label className="fw-bold">
              <i className="mdi mdi-timer-plus me-1 text-primary"></i>Mezat Uzatma Hakkı
            </Label>
            <Input
              type="number" min="0"
              value={formData.MEZAT_UZATMA_HAKKI}
              onChange={(e) => setFormData({ ...formData, MEZAT_UZATMA_HAKKI: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setModal(false)} disabled={isSaving}>İptal</Button>
          <Button color="primary" onClick={handleSave} disabled={isSaving}>
            {isSaving ? <Spinner size="sm" className="me-1" /> : <i className="mdi mdi-content-save me-1"></i>}
            Kaydet
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default KullaniciHaklari;
